import styled from 'styled-components'
import { COLORS } from 'consts/colors'

export const TtsControlsButtonsWrapper = styled.div<{ $isActive: boolean }>`
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  height: ${({ $isActive }) => ($isActive ? '20px' : '0px')};
  margin-bottom: ${({ $isActive }) => ($isActive ? '4px' : '0px')};
  overflow: hidden;
  transition:
    height 0.2s linear,
    margin-bottom 0.2s linear;
`

export const TtsItemLeftControlsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

export const TtsControlsDivider = styled.div`
  width: 1px;
  height: 10px;
  background-color: ${COLORS.primarySemiLight};
`
